<template>
  <div id="idle" class="layer">
    <div class="inner">
      <p class="layerTitle">{{locale.idle_logout}}</p>
      <div class="timer">
        <p>{{locale.message_idle_logout_1}}</p>
        <p>{{locale.message_idle_logout_2}}</p>
        <div class="remain">{{locale.remain_time}}: <span class="time colorPrimary">{{timer}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Idle',
  props: [
    'locale'
  ],
  computed: {
    timer () {
      return this.time / 1000
    }
  },
  created () {
    // alert('60분동안 활동이 감지되지 않아 접속이 종료되었습니다.')
    let timerId = setInterval(() => {
      this.time -= 1000
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId)
      if (this.time < 0) {
        clearInterval(timerId)
        // alert(this.locale.alert_idle_logout)
        this.$emit('logout')
      }
    }, 1000)
  },
  data () {
    return {
      time: 60000
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  z-index: 9999;
  .inner {
    max-width: 800px;
    text-align: center;
    font-size: 1.2em;
    border-radius: 8px;
  }
  .remain {
    margin-top: 0.3em;
    font-size: 1.6em;
    font-weight: bold;
    .time {
      font-size: 1.6em;
    }
  }
}
</style>
